import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';

@Component({
    selector: 'app-chart-kpi-pie',
    templateUrl: './chart-kpi-pie.component.html',
    styleUrls: ['./chart-kpi-pie.component.scss'],
    standalone: false
})
export class ChartKpiPieComponent implements OnInit, OnChanges {
  @Input() hc: any = {};
  @Input() chartData: any;
  @Input() metrics: any = {};
  @Input() chartWidth: number = 0;

  pieChart: any;
  subHeading: string = '';

  constructor() {}

  ngOnInit(): void {
    this.fnSetSubHeading();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.pieChart = this.buildChart();
  }

  buildChart() {
    const chartData = this.chartData;
    const data = chartData?.data.map((data: any) => data);
    return {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie',
        marginBottom: 75,
        margin: [0, 0, 0, 0],
        spacingTop: 0,
        spacingBottom: 0,
        spacingLeft: 0,
        spacingRight: 0,
      },
      title: '',
      tooltip: {
        pointFormat: '{series.name}: <b>{point.y}</b>',
      },
      accessibility: {
        point: {
          valueSuffix: '%',
        },
      },
      plotOptions: {
        pie: {
          size: '100%',
          allowPointSelect: false,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            format: '{point.percentage:.1f}%',
            distance: '5%',
          },
          showInLegend: true,
        },
      },
      series: [
        {
          name: '',
          colorByPoint: true,
          data,
        },
      ],
      legend: {
        align: 'center',
        verticalAlign: 'bottom',
        itemStyle: {
          fontFamily: 'Nunito',
          fontWeight: 600,
          fontSize: '10px',
        },
        floating: true,
        alignColumns: false,
      },
      credits: {
        enabled: false,
      },
      responsive: {
        rules: [
          {
            condition: {
              maxWidth: 500,
            },
            chartOptions: {
              yAxis: {
                labels: {
                  align: 'left',
                  x: 0,
                  y: -2,
                },
                title: {
                  text: '',
                },
              },
            },
          },
        ],
      },
    };
  }

  fnSetSubHeading() {
    if (this.metrics && Object.keys(this.metrics).length !== 0) {
      this.subHeading =
        '(' + this.metrics.text + ': ' + this.metrics.value + ')';
    }
    if (this.chartData?.isTrumindsOwned) {
      this.subHeading = '(Truminds Owned)';
    } else if (
      !this.chartData?.isTrumindsOwned &&
      this.chartData?.kpiName.includes('Asset')
    ) {
      this.subHeading = '(Client Owned)';
    }
  }
}
